import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled(Link)`
  width: 100%;
  background-color: white;
  border-radius: 8px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  text-decoration: none;
  color: black;
`;

const DescriptionContainer = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
`;

const Image = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
`;

const Description = styled.span`
  font-size: 14px;
  margin-bottom: 5px;
`;

const Price = styled.span`
  font-size: 14px;
  display: block;
`;

const modules = {
  Image,
  Container,
  DescriptionContainer,
  Description,
  Price,
};

export default modules;
